import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface ToolDetailsFieldsInvitationPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ToolDetailsFieldsInvitationPopup = ({
  open,
  onClose,
  onConfirm,
}: ToolDetailsFieldsInvitationPopupProps): JSX.Element => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm invite mode change</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          All users will be invited to the tool. This may result in additional
          costs being charged.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ToolDetailsFieldsInvitationPopup;
